import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
  title?: string;
  className?: string;
};

export function CertificationScrollableCell({ children, title, className = "" }: Props) {
  return (
    <div className={`iso27001-scrollable-cell ${className}`.trim()} title={title}>
      {children}
    </div>
  );
}
